export default __webpack_public_path__ + "static/media/steppe.1afc7d0b.svg";